module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e068809bad5b36df209c78f213ebe958.png";